/**
 * RadNeo™ Design System — Typography Tokens
 *
 * Font families:
 *   - Inter: body / UI (300–700)
 *   - Poppins: headings (600–700)
 *   - Gotham: brand moments (500–700)
 */

export const fontFamily = {
  body: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
  heading: '"Poppins", "Inter", "Roboto", sans-serif',
  brand: '"Gotham", "Poppins", "Inter", sans-serif',
} as const;

export const typography = {
  h1: {
    fontFamily: fontFamily.heading,
    fontSize: '2rem',      // 32px
    fontWeight: 700,
    lineHeight: 1.2,
    letterSpacing: '-0.02em',
  },
  h2: {
    fontFamily: fontFamily.heading,
    fontSize: '1.5rem',    // 24px
    fontWeight: 600,
    lineHeight: 1.25,
    letterSpacing: '-0.01em',
  },
  h3: {
    fontFamily: fontFamily.heading,
    fontSize: '1.25rem',   // 20px
    fontWeight: 600,
    lineHeight: 1.3,
    letterSpacing: '-0.01em',
  },
  h4: {
    fontFamily: fontFamily.heading,
    fontSize: '1.125rem',  // 18px
    fontWeight: 600,
    lineHeight: 1.35,
    letterSpacing: '-0.005em',
  },
  body1: {
    fontFamily: fontFamily.body,
    fontSize: '1rem',      // 16px
    fontWeight: 400,
    lineHeight: 1.5,
    letterSpacing: '0em',
  },
  body2: {
    fontFamily: fontFamily.body,
    fontSize: '0.875rem',  // 14px
    fontWeight: 400,
    lineHeight: 1.5,
    letterSpacing: '0.01em',
  },
  caption: {
    fontFamily: fontFamily.body,
    fontSize: '0.75rem',   // 12px
    fontWeight: 500,
    lineHeight: 1.4,
    letterSpacing: '0.02em',
  },
  label: {
    fontFamily: fontFamily.body,
    fontSize: '0.75rem',   // 12px
    fontWeight: 600,
    lineHeight: 1.4,
    letterSpacing: '0.025em',
    textTransform: 'none' as const,
  },
  button: {
    fontFamily: fontFamily.body,
    fontSize: '0.875rem',  // 14px
    fontWeight: 500,
    lineHeight: 1.5,
    letterSpacing: '0.01em',
    textTransform: 'none' as const,
  },
  brand: {
    fontFamily: fontFamily.brand,
    fontSize: '1.5rem',    // 24px
    fontWeight: 700,
    lineHeight: 1.2,
    letterSpacing: '-0.02em',
  },
  overline: {
    fontFamily: fontFamily.body,
    fontSize: '0.625rem',  // 10px
    fontWeight: 600,
    lineHeight: 1.2,
    letterSpacing: '0.1em',
    textTransform: 'uppercase' as const,
  },
} as const;
